import { render, staticRenderFns } from "./FreeBlocksSettings.vue?vue&type=template&id=4543830f&scoped=true"
import script from "./FreeBlocksSettings.vue?vue&type=script&lang=ts"
export * from "./FreeBlocksSettings.vue?vue&type=script&lang=ts"
import style0 from "./FreeBlocksSettings.vue?vue&type=style&index=0&id=4543830f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543830f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4543830f')) {
      api.createRecord('4543830f', component.options)
    } else {
      api.reload('4543830f', component.options)
    }
    module.hot.accept("./FreeBlocksSettings.vue?vue&type=template&id=4543830f&scoped=true", function () {
      api.rerender('4543830f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/FreeBlocksSettings.vue"
export default component.exports